// extracted by mini-css-extract-plugin
module.exports = {"container":"paypal-button-braintree_container__ipKqH","frame":"paypal-button-braintree_frame__mCgPY","loaderContainer":"paypal-button-braintree_loaderContainer__wd1wy"};